import Alert from '@mui/material/Alert';
import type { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

import { reasonMessage } from '../../../i18n';

import type { ScreenFailure } from './screen-failure';

/**
 * The catalogue text of a failure (I12): never a problem title or a body. MUI's Alert is
 * `role="alert"`, so it is announced. Shared by E3 and E12 (S9 R20).
 */
export function ReasonText({ failure }: { readonly failure: ScreenFailure }): ReactElement {
  const { t } = useTranslation();
  const message = reasonMessage(failure.reasonCode, failure.params);
  return <Alert severity="error">{t(message.key, message.values)}</Alert>;
}
